import Joi from 'joi';

export const VideoSchema = Joi.object({
  title: Joi.string().required(),
  description: Joi.string().required(),
  pined: Joi.string().required(),
  url: Joi.string().required(),
});
